<div [ngClass]="customCss()" [ngStyle]="customStyle() ?? {}">
  <dojo-super-latex [content]="content()" />
</div>
